import { faUserPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, DatePicker, Dropdown, Form, Input, Row, Select, Space, Spin } from "antd";
import { Tabs } from 'antd';
import moment from "moment/moment";
import { useState } from "react";

const EditProfile = () => {
    const [selectedTab, SetSelectedTab] = useState('Parent Details');

    const tabChange = (key) => {
        SetSelectedTab(key);
    }

    const parentDetails =
        <div className="shadow py-1 px-3">
            <h5 className="py-2 fw-bold"><FontAwesomeIcon icon={faUserPen} />  {selectedTab}</h5>
            <hr></hr>
            <Form layout="vertical" className="editpage">
                <Row gutter={[20, 6]}>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="First Name" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Emma " />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Last Name" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Shelton" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="ID" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="66585" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Date of Birth" className="fw-bold " required >
                            <DatePicker className="py-2 rounded-0 w-100" defaultValue={moment()} format={"DD-MM-YYYY"} />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Social security number" className="fw-bold " required>
                            <Input className="py-2 rounded-0" defaultValue="27583532" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Gender" className="fw-bold " required>
                            <Select size="large" defaultValue="Male">
                                <Option>Select</Option>
                                <Option>Male</Option>
                                <Option>Female</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Race" className="fw-bold " required>
                            <Select size="large" defaultValue="Normal">
                                <Option>Select</Option>
                                <Option>Normal</Option>
                                <Option>Speed</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Religion" className="fw-bold " required>
                            <Select size="large" defaultValue="Hindu">
                                <Option>Select</Option>
                                <Option>Hindu</Option>
                                <Option>Christian</Option>
                                <Option>Muslims</Option>
                                <Option>Others</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Mothers Maiden Name" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Ch" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Marital Status" className="fw-bold " required>
                            <Select size="large" defaultValue="single">
                                <Option>Select</Option>
                                <Option>Single</Option>
                                <Option>Married</Option>
                                <Option>Separated</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Spouse Name" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Ramya" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Primary Care Physician" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Venkatesh" />
                        </Form.Item>
                    </Col>
                </Row>
                <h5 className="p-2 fw-bold">Address</h5>
                <Row gutter={[20, 6]}>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Line 1" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Line 1" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Line 2" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Line 2" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Zip" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="505327" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="State" className="fw-bold " required>
                            <Select size="large" defaultValue="TG">
                                <Option>Select</Option>
                                <Option>TG</Option>
                                <Option>AP</Option>
                                <Option> <Spin size="small" /></Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="City" className="fw-bold " required>
                            <Select size="large" defaultValue="Hyderabad">
                                <Option>Select</Option>
                                <Option>Hyderabad</Option>
                                <Option>Karimnagar</Option>
                                <Option>Siddipet</Option>
                                <Option>Warangal</Option>
                                <Option> <Spin size="small" /></Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[20, 6]}>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Primary Phone #" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="8787878787" type="number" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Alternate Phone #" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="5454878787" type="number" />
                        </Form.Item>
                    </Col>
                </Row>
                <h5 className="p-2 fw-bold">Nearest Relative/ Emergency Contact</h5>
                <Row gutter={[20, 6]}>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="First Name" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Ram" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Last Name" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="jai" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="ID" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="86896" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Date of Birth" className="fw-bold " required >
                            <DatePicker className="py-2 rounded-0 w-100" defaultValue={moment()} format={"DD-MM-YYYY"} />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Relationship to Patient" className="fw-bold " required>
                            <Input className="py-2 rounded-0" defaultValue="Friend" />
                        </Form.Item>
                    </Col>
                </Row>
                <h5 className="p-2 fw-bold">Address</h5>
                <Row gutter={[20, 6]}>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Line 1" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Line 1" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Line 2" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Line 2" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Zip" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="505327" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="State" className="fw-bold " required>
                            <Select size="large" defaultValue="TG">
                                <Option>Select</Option>
                                <Option>TG</Option>
                                <Option>AP</Option>
                                <Option> <Spin size="small" /></Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="City" className="fw-bold " required>
                            <Select size="large" defaultValue="Hyderabad">
                                <Option>Select</Option>
                                <Option>Hyderabad</Option>
                                <Option>Karimnagar</Option>
                                <Option>Siddipet</Option>
                                <Option>Warangal</Option>
                                <Option> <Spin size="small" /></Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[20, 6]}>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Primary Phone #" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="8787878787" type="number" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Alternate Phone #" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="5454878787" type="number" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <Space direction="horizontal" className="my-2">
                <Button className="text fw-bold py-1">Save</Button>
                <Button className="btn px-3 py-1" >Next</Button>
            </Space>
        </div>

    const guardianDetails =
        <div className="shadow py-1 px-3">
            <h5 className="py-2 fw-bold"><FontAwesomeIcon icon={faUserPen} />  {selectedTab}</h5>
            <hr></hr>
            <Form layout="vertical" className="editpage">
                <Row gutter={[20, 6]}>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="First Name" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Emma " />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Last Name" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Shelton" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="ID" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="66585" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Date of Birth" className="fw-bold " required >
                            <DatePicker className="py-2 rounded-0 w-100" defaultValue={moment()} format={"DD-MM-YYYY"} />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Social security number" className="fw-bold " required>
                            <Input className="py-2 rounded-0" defaultValue="27583532" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Gender" className="fw-bold " required>
                            <Select size="large" defaultValue="Male">
                                <Option>Select</Option>
                                <Option>Male</Option>
                                <Option>Female</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <h5 className="p-2 fw-bold">Address</h5>
                <Row gutter={[20, 6]}>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Line 1" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Line 1" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Line 2" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Line 2" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Zip" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="505327" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="State" className="fw-bold " required>
                            <Select size="large" defaultValue="TG">
                                <Option>Select</Option>
                                <Option>TG</Option>
                                <Option>AP</Option>
                                <Option> <Spin size="small" /></Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="City" className="fw-bold " required>
                            <Select size="large" defaultValue="Hyderabad">
                                <Option>Select</Option>
                                <Option>Hyderabad</Option>
                                <Option>Karimnagar</Option>
                                <Option>Siddipet</Option>
                                <Option>Warangal</Option>
                                <Option> <Spin size="small" /></Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[20, 6]}>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Primary Phone #" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="8787878787" type="number" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Alternate Phone #" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="5454878787" type="number" />
                        </Form.Item>
                    </Col>
                </Row>
                <h5 className="p-2 fw-bold">Employment details</h5>
                <Row gutter={[20, 6]}>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Employment Status" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Ram" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Name of the Employer" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="jai" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[20, 6]}>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Address of Employer" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="Krishna nagar" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Zip" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="598886" />
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="State" className="fw-bold " required>
                            <Select size="large" defaultValue="TG">
                                <Option>Select</Option>
                                <Option>TG</Option>
                                <Option>AP</Option>
                                <Option> <Spin size="small" /></Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="City" className="fw-bold " required>
                            <Select size="large" defaultValue="Hyderabad">
                                <Option>Select</Option>
                                <Option>Hyderabad</Option>
                                <Option>Karimnagar</Option>
                                <Option>Siddipet</Option>
                                <Option>Warangal</Option>
                                <Option> <Spin size="small" /></Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col lg={8} md={10} sm={20} xs={24}>
                        <Form.Item label="Employee Phone #" className="fw-bold " required>
                            <Input className="py-2 rounded-0" value="5454878787" type="number" />
                        </Form.Item>
                    </Col>
                </Row>

            </Form>
            <Space direction="horizontal" className="my-2">
                <Button className="text fw-bold py-1">Previous</Button>
                <Button className="btn px-3 py-1">Save</Button>
            </Space>
        </div>



    return (<section>
        <div>
            <h5>Update Edit Information</h5>
        </div>
        <Tabs onChange={tabChange}
            defaultActiveKey="1"
            style={{
                marginBottom: 32,
            }}
            items={[{
                key: 'Patient Demographic Information',
                label: `Parent Details`,
                children: parentDetails,
            },
            {
                key: 'Parent/Guardian InformationD',
                label: `Parent/Guardian Information`,
                children: guardianDetails,
            },]}
        />

    </section>)
}

export default EditProfile;
